import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { Marca } from '@/types/types'
import { MarcaService } from '@/services/MarcaService'
@Module({
  namespaced: true,
  name: 'marcas',
  store,
  dynamic: true
})
class MarcaModule extends VuexModule {
  items: Marca[] = []
  service = new MarcaService()

  @Action({ commit: 'setItems' })
  async fetchAll () {
    const marcas = await this.service.fectchAllRequest()
    return marcas.data.data
  }

  @Mutation
  setItems (items: Marca[]) {
    this.items = items
  }
}

export default getModule(MarcaModule)
